var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page-content"},[_c('HomeHeaderSection'),_c('SloganSection'),_c('VideoSection',{attrs:{"id":"landingVideo","src":"https://www.youtube.com/embed/m1fLGTMeRSc?controls=0"}}),_c('ImageUnderSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }